import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../../infrastructure/services/auth.service';
import { SxSecurityService } from '../../infrastructure/services/sxSecurity.service';
import { Router, ActivatedRoute } from '@angular/router';
import { StyleService } from 'app/infrastructure/services/style.service';
import { SxTranslationService } from 'app/infrastructure/services/translation-service.service';
import { CacheService } from 'app/infrastructure/services/cache.service';

import { ConfigService, RootConfigurationItem } from 'app/infrastructure/services/config.service';
import { SxHttpService } from 'app/infrastructure/services/sxHttp.service';
@Component({
  selector: 'app-desktop',
  templateUrl: './desktop.component.html',
  // styleUrls: ['./desktop.component.css'],
})
export class DesktopComponent implements OnInit, OnDestroy {
  itemOver: string;
  currentUser = this.authService.currentUser;
  rootItems: RootConfigurationItem[];
  constructor(
    public authService: AuthService,
    public securityService: SxSecurityService,
    public router: Router,
    public aRoute: ActivatedRoute,
    private styleService: StyleService,
    private rootConfigService: ConfigService,
    private sxTranslationService: SxTranslationService,
    private sxHttp: SxHttpService,
    private sxCacheService: CacheService
  ) { }

  ngOnInit() {
    if (this.sxCacheService.isContextCached()) {
      let userLang = this.sxCacheService.getCurrentUserLang();
      if (userLang != null && userLang !== window.localStorage.i18nextLng) {
        this.sxTranslationService.setLanguage(userLang);
        window.location.reload();
      }
    }

    this.styleService.addStyle(
      'DesktopComponent',
      require('./desktop.component.css')
    );
    document
      .getElementById('container-principal')
      .classList.remove('container');
    document.getElementById('breadcrumb-principal').style.display = 'none';
    this.rootConfigService.getRootConiguration().subscribe((x) => {
      this.rootItems = x;
    });
  }
  logout() {
    this.securityService.logout();
  }
  ngOnDestroy() {
    this.styleService.removeStyle('DesktopComponent');
    document.getElementById('container-principal').classList.add('container');
    document.getElementById('breadcrumb-principal').style.display = 'block';
  }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/desktop/desktop.component.ts